export default __webpack_public_path__ + "static/bell-ringing-0b14dcdefde3e590385126dadb6b0761.mp3";